module.exports = __webpack_public_path__ + "static/media/Statua_044.60c35262.jpg";